import { requests } from "../../../../api/agent"

export default {
	create        : (params) => requests.post('/ReMessageToAdminType/create', params),
	update        : (params) => requests.post('/ReMessageToAdminType/update', params),
	delete        : (params) => requests.getWithParams('/ReMessageToAdminType/delete', params),
	restore       : (params) => requests.getWithParams('/ReMessageToAdminType/restore', params),
	getPaged      : (params) => requests.getWithParams('/ReMessageToAdminType/getPaged', params),
	getPagedAudit : (params) => requests.getWithParams('/ReMessageToAdminType/getPagedAudit', params),
	getPagedAll   : (params) => requests.getWithParams('/ReMessageToAdminType/getPagedAll', params),
	getList       : (params) => requests.getWithParams('/ReMessageToAdminType/getList', params)
}